import React, { Fragment } from "react";
import { loadShoppingList } from "./Fetching";
import Button from "../Button";

export default function RegisterButtons({ list, registerItems }) {
  const registerList = shoppingList => {
    loadShoppingList(shoppingList.id).then(json => {
      registerShoppingList(json.shopping_list);
    });
  };

  const registerShoppingList = shoppingList => {
    const items = shoppingList.items.map(shoppingListItem => {
      const product = {
        id: shoppingListItem.product_id,
        name: shoppingListItem.product_name,
        schedules: []
      };
      const test_schedule = {
        client_suite_id: shoppingListItem.client_suite_id,
        client_suite_name: shoppingListItem.client_suite_name,
        client_specification_id: shoppingListItem.client_specification_id,
        client_specification_name: shoppingListItem.client_specification_name,
        sample_information_id: shoppingListItem.sample_information_id,
        sample_information_name: shoppingListItem.sample_information_name
      };

      return {
        count: 1,
        product,
        test_schedule
      };
    });
    registerItems(items);
  };

  if (list.sample_count === 0) return null;

  return (
    <Fragment>
      <Button tiny block title="Register Now" onClick={() => registerList(list)} />
    </Fragment>
  );
}
